import { cn } from '@/design-system/lib/cn';

import { BRAND } from './brand';
import BrandLogo from './BrandLogo';

/**
 * A marca: o símbolo, "Live Gospel" e, embaixo, "Tecnologia para Igrejas" em caixa alta — o subtítulo.
 * `md` no login e no cadastro público; `sm` no convite e na senha nova.
 */
export default function BrandMark({ size = 'md' }: { size?: 'sm' | 'md' }) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandLogo decorative className={size === 'md' ? 'h-10.5 w-auto' : 'h-9 w-auto'} />
      <span className="flex flex-col gap-0.5 leading-[1.05]">
        <span
          className={cn('font-extrabold tracking-[-0.025em]', size === 'md' ? 'text-heading' : 'text-title')}
        >
          {BRAND.name}
        </span>
        <span className="text-micro font-bold tracking-wider text-primary uppercase">{BRAND.subtitle}</span>
      </span>
    </div>
  );
}
